import React, { useState } from 'react';
import {
  Button, Menu, MenuItem, ListSubheader, ListItemText, Typography, Box,
} from '@mui/material';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import LaptopIcon from '@mui/icons-material/Laptop';
import TabletIcon from '@mui/icons-material/Tablet';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FRAMES = [
  {
    category: 'None',
    options: [
      { key: 'none', label: 'No frame', dims: null },
    ],
  },
  {
    category: 'iOS',
    options: [
      { key: 'ios-iphone16pro', label: 'iPhone 16 Pro', dims: { width: 390, height: 844 } },
      { key: 'ios-iphone16promax', label: 'iPhone 16 Pro Max', dims: { width: 430, height: 932 } },
      { key: 'ios-ipadpro11', label: 'iPad Pro 11"', dims: { width: 834, height: 1194 } },
      { key: 'ios-ipadpro13', label: 'iPad Pro 13"', dims: { width: 1024, height: 1366 } },
    ],
  },
  {
    category: 'Android',
    options: [
      { key: 'android-pixel9', label: 'Pixel 9', dims: { width: 412, height: 915 } },
      { key: 'android-s24', label: 'Samsung Galaxy S24', dims: { width: 360, height: 780 } },
    ],
  },
  {
    category: 'Web',
    options: [
      { key: 'web-desktop', label: 'Desktop 1440×900', dims: { width: 1440, height: 900 } },
      { key: 'web-laptop', label: 'Laptop 1280×800', dims: { width: 1280, height: 800 } },
      { key: 'web-tablet', label: 'Tablet Landscape 1024×768', dims: { width: 1024, height: 768 } },
    ],
  },
];

const allOptions = FRAMES.flatMap((g) => g.options);

const FramePicker = ({ frameType = 'none', onFrameChange }) => {
  const [anchor, setAnchor] = useState(null);
  const current = allOptions.find((o) => o.key === frameType) || allOptions[0];

  const icon = frameType.startsWith('ios') || frameType.startsWith('android')
    ? <PhoneIphoneIcon sx={{ fontSize: 14 }} />
    : frameType.startsWith('web')
      ? <LaptopIcon sx={{ fontSize: 14 }} />
      : <TabletIcon sx={{ fontSize: 14 }} />;

  return (
    <>
      <Button
        size="small" variant="outlined"
        startIcon={icon}
        endIcon={<ExpandMoreIcon sx={{ fontSize: 14 }} />}
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{
          borderRadius: 1.5, textTransform: 'none', fontSize: 12,
          color: '#555', borderColor: '#ddd', px: 1.5, py: 0.5,
          '&:hover': { borderColor: '#bbb', background: '#f5f5f5' },
        }}
      >
        {current.label}
      </Button>
      <Menu
        anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
        PaperProps={{ sx: { borderRadius: 2, minWidth: 220 } }}
      >
        {FRAMES.map((group) => [
          <ListSubheader key={group.category} sx={{ fontSize: 10, fontWeight: 700, lineHeight: '28px', color: '#aaa', letterSpacing: '0.06em' }}>
            {group.category.toUpperCase()}
          </ListSubheader>,
          ...group.options.map((opt) => (
            <MenuItem
              key={opt.key}
              selected={opt.key === frameType}
              onClick={() => { onFrameChange?.(opt); setAnchor(null); }}
              sx={{ py: 0.5, px: 2 }}
            >
              <ListItemText
                primary={<Typography sx={{ fontSize: 13 }}>{opt.label}</Typography>}
                secondary={opt.dims ? <Typography sx={{ fontSize: 11, color: '#999' }}>{opt.dims.width}×{opt.dims.height}</Typography> : null}
              />
            </MenuItem>
          )),
        ])}
      </Menu>
    </>
  );
};

export default FramePicker;
